/** Platform admin gate — lawyers never get admin panel access via these checks. */

export const ADMIN_EMAILS = [
  'mkrahim.law@gmail.com',
  'rhm@gmail.com',
] as const;

const adminEmailSet = new Set(
  ADMIN_EMAILS.map((e) => e.toLowerCase()),
);

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return adminEmailSet.has(email.toLowerCase());
}

export function isPlatformAdmin(email: string | null | undefined): boolean {
  return isAdminEmail(email);
}
